import React from "react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";
import { ContactForm } from "@/components/ContactForm";

const B2BForm = () => {
  const { t } = useLang();

  return (
    <section id="hosteleria" className="bg-[#3B2523] py-24 md:py-32 px-6 md:px-12 lg:px-20 scroll-mt-[104px]">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20">
        <div>
          <Reveal>
            <p className="text-[#F4D35E] uppercase tracking-[0.25em] text-xs font-semibold mb-6">
              {t.b2b.tag}
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#F5F1E8] leading-[1.02]">
              {t.b2b.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#E6D9B6]/70 text-lg mt-7 leading-relaxed max-w-md">
              {t.b2b.text}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <ContactForm kind="horeca" tone="dark" showBusiness testId="b2b-form" id="formulario-hosteleria" />
        </Reveal>
      </div>
    </section>
  );
};

export default B2BForm;
